import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';
//import { RegistrationService } from '../../registration.service';

@Component({
  selector: 'app-acchead-grid',
  templateUrl: './acchead-grid.component.html',
  styleUrls: ['./acchead-grid.component.css']
})
export class AccheadGridComponent implements OnInit {
  maintitle="New AccHead & SubAccHead Creation";
  title = "AccHead & SubAccHead List";
  AccountHeadDetails:any={};
  accountHeads;  
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  subHeadList:any=[];
  sh:any={}

  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllAccountHeads(this.itemsPerPage, 1);
  }


   
  SetUrl(Id:any,mode:any)
  {
    localStorage.setItem('accounthead',Id);
    localStorage.setItem('mode', mode);
  }

  GetAllAccountHeads(itemsPerPage: number, pageNo: number) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllAccountHeads(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.accountHeads=data.AccountHeadPaginationModels; 
         // this.subHeadList =data.AccountHeadPaginationModels.AccountSubHead;      
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;  
          console.log(data);        
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllAccountHeads(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllAccountHeads(this.itemsPerPage, pageNo);
  }

  //variable : holds the data from API
 // districtList;
 onSearch(s,itemsPerPage: number, pageNo: number) 
 {
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
   else {
     document.getElementById('loader-spinner').style.display = "block";
     this.userService.searchAccountHead(searchCriteria, searchText, itemsPerPage, pageNo)
       .subscribe(
         (data:any) => {
           this.accountHeads = data.AccountHeadPaginationModels;           
           this.totalItems = data.TotalItemsCount;           
           this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }
 }

  deleteAccountHead(accountHead: string)
  {
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteAccountHead(accountHead).subscribe(
          (data:any) => {
            swal('','Account Head Deleted!','success');
            this.GetAllAccountHeads(this.itemsPerPage, 1);
            this.s.SearchText = "";
            this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.HandlerError(error);
          });
      }
    })  
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/acchead-grid/acchead-grid.component.ts